'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('./tslib.es6-f8b34207.js');
var device = require('./device.js');
require('ua-parser-js');

var DeviceAsync = /** @class */ (function () {
    function DeviceAsync() {
        var _this = this;
        this.smartTvInfo = {};
        this.info = {};
        this.loading = true;
        this.callbacks = [];
        this.info = device.device.info;
        if (this.isSmartTv()) {
            window.addEventListener('load', function () {
                _this.getSmartTvInfo().then(function (info) {
                    _this.smartTvInfo = info;
                    _this.callbacks.map(function (cb) {
                        cb(true);
                    });
                    _this.callbacks = [];
                    _this.loading = false;
                });
            });
        }
        else {
            this.loading = false;
        }
    }
    DeviceAsync.prototype.getDeviceType = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? 'smarttv' : device.device.getDeviceType()];
            });
        });
    };
    DeviceAsync.prototype.isAnyMobile = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isAnyMobile()];
            });
        });
    };
    DeviceAsync.prototype.isAppleDevice = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isAppleDevice()];
            });
        });
    };
    DeviceAsync.prototype.isHuaweiDevice = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isHuaweiDevice()];
            });
        });
    };
    DeviceAsync.prototype.isTablet = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isTablet()];
            });
        });
    };
    DeviceAsync.prototype.isMobile = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isMobile()];
            });
        });
    };
    DeviceAsync.prototype.isWearable = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isWearable()];
            });
        });
    };
    DeviceAsync.prototype.isIpad = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isIpad()];
            });
        });
    };
    DeviceAsync.prototype.isIphone = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isIphone()];
            });
        });
    };
    /** OS */
    DeviceAsync.prototype.getOsName = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.loading) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.wait()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.isSmartTv() ? this.smartTvInfo.os.name : device.device.getOsName() || 'unknown'];
                }
            });
        });
    };
    DeviceAsync.prototype.getOsVersion = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.loading) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.wait()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.isSmartTv() ? this.smartTvInfo.os.version : device.device.getOsVersion() || 'unknown'];
                }
            });
        });
    };
    DeviceAsync.prototype.isSmartTv = function () {
        return !!window.tizen || !!window.webOS;
    };
    DeviceAsync.prototype.isTizenOS = function () {
        return !!window.tizen && window.webapis;
    };
    DeviceAsync.prototype.isLGWebOS = function () {
        return !!window.webOS;
    };
    DeviceAsync.prototype.isAndroid = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isAndroid()];
            });
        });
    };
    DeviceAsync.prototype.isWindows = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isWindows()];
            });
        });
    };
    DeviceAsync.prototype.isIOS = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isIOS()];
            });
        });
    };
    DeviceAsync.prototype.isMacOs = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isMacOs()];
            });
        });
    };
    /** browsers */
    DeviceAsync.prototype.getBrowserName = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.loading) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.wait()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.isSmartTv() ? this.smartTvInfo.browser.name : device.device.getBrowserName() || 'unknown'];
                }
            });
        });
    };
    DeviceAsync.prototype.getBrowserVersion = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.loading) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.wait()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.isSmartTv() ? this.smartTvInfo.browser.version : device.device.getBrowserVersion() || '0'];
                }
            });
        });
    };
    DeviceAsync.prototype.isIE = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isIE()];
            });
        });
    };
    DeviceAsync.prototype.isEdge = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isEdge()];
            });
        });
    };
    DeviceAsync.prototype.isSafari = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isSafari()];
            });
        });
    };
    DeviceAsync.prototype.isOpera = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isOpera()];
            });
        });
    };
    DeviceAsync.prototype.isFirefox = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isFirefox()];
            });
        });
    };
    DeviceAsync.prototype.isChrome = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isChrome()];
            });
        });
    };
    /** desktop sizes */
    DeviceAsync.prototype.isMobileSize = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isMobileSize()];
            });
        });
    };
    DeviceAsync.prototype.isMobileScreen = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isMobileScreen()];
            });
        });
    };
    DeviceAsync.prototype.isTabletScreen = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isTabletScreen()];
            });
        });
    };
    DeviceAsync.prototype.isDesktopScreen = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                return [2 /*return*/, this.isSmartTv() ? false : device.device.isDesktopScreen()];
            });
        });
    };
    DeviceAsync.prototype.getSmartTvInfo = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            var info;
            return tslib_es6.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        info = {
                            browser: {
                                major: null,
                                name: null,
                                version: null
                            },
                            cpu: {
                                architecture: null
                            },
                            device: {
                                model: null,
                                type: null,
                                vendor: null
                            },
                            engine: {
                                name: null,
                                version: null
                            },
                            os: {
                                name: null,
                                version: null
                            },
                            ua: null
                        };
                        if (!this.isLGWebOS()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getWevOsInfo(info)];
                    case 1:
                        info = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!this.isTizenOS()) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getTizenInfo(info)];
                    case 3:
                        info = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, info];
                }
            });
        });
    };
    DeviceAsync.prototype.getTizenInfo = function (info) {
        var _a, _b;
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_c) {
                info.browser.name = info.os.name = 'Tizen';
                info.device.type = 'smarttv';
                info.device.vendor = 'samsung';
                if ((_a = window === null || window === void 0 ? void 0 : window.webapis) === null || _a === void 0 ? void 0 : _a.productinfo) {
                    info.playerVersion = webapis.avplay && webapis.avplay.getVersion ? webapis.avplay.getVersion() : null;
                    // info.browser.version = info.os.version = window.webapis.productinfo.getVersion() || ''
                    info.device.model = window.webapis.productinfo.getModel() || '';
                    info.modelCode = window.webapis.productinfo.getModelCode() || '';
                }
                if ((_b = window === null || window === void 0 ? void 0 : window.tizen) === null || _b === void 0 ? void 0 : _b.systeminfo) {
                    try {
                        if (tizen.systeminfo.getCapability) {
                            info.browser.version = info.os.version = tizen.systeminfo.getCapability('http://tizen.org/feature/platform.version');
                        }
                        else if (tizen.systeminfo.getCapabilities) {
                            info.browser.version = info.os.version = tizen.systeminfo.getCapabilities().platformVersion;
                        }
                    }
                    catch (e) {
                        console.warn(e);
                        info.browser.version = info.os.version = '3'; // minimal supported version
                    }
                }
                else {
                    console.warn('window.tizen and window.webapis - not available to read info!');
                }
                return [2 /*return*/, info];
            });
        });
    };
    DeviceAsync.prototype.getWevOsInfo = function (info) {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                info.device.type = 'smarttv';
                info.device.vendor = 'lg';
                info.browser.name = info.os.name = 'WebOs';
                if (!window.webOS) {
                    console.warn('window.webOS - not available to read info!');
                    return [2 /*return*/, info];
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        window.webOS.deviceInfo(function (device) {
                            info.browser.version = info.os.version = device.version || '1.em';
                            info.device.model = device.modelName || '';
                            [
                                'sdkVersion',
                                'versionMajor',
                                'versionMinor',
                                'versionDot',
                                'uhd',
                                'uhd8K',
                                'oled',
                                'ddrSize',
                                'hdr10',
                                'dolbyVision',
                                'dolbyAtmos',
                                'modelName',
                                'modelNameAscii'
                            ].map(function (key) {
                                info[key] = device[key];
                            });
                            resolve(info);
                        });
                    })];
            });
        });
    };
    DeviceAsync.prototype.tizenConnectionsStatus = function () {
        if (!window.webapis) {
            return 'unavailable';
        }
        try {
            var connectionType = webapis.network.getActiveConnectionType();
            switch (connectionType) {
                case webapis.network.NetworkActiveConnectionType.WIFI:
                    return 'wifi';
                case webapis.network.NetworkActiveConnectionType.ETHERNET:
                    return 'ethernet';
                case webapis.network.NetworkActiveConnectionType.CELLULAR:
                    return 'cellular';
                case webapis.network.NetworkActiveConnectionType.DISCONNECTED:
                default:
                    return 'unavailable';
            }
        }
        catch (e) {
            console.warn(e);
            return 'unavailable';
        }
    };
    DeviceAsync.prototype.webOsConnectionsStatus = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                if (!window.webOSDev || !window.webOSDev.getStatus) {
                    return [2 /*return*/, 'unavailable'];
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        webOSDev.connection.getStatus({
                            onSuccess: function (res) {
                                if (res.isInternetConnectionAvailable === false) ;
                                else {
                                    if (res.wired) {
                                        resolve('ethernet');
                                    }
                                    else if (res.wifi) {
                                        // do something
                                        resolve('wifi');
                                    }
                                }
                            },
                            onFailure: function (res) {
                                console.warn(res);
                                resolve('unavailable');
                            },
                            subscribe: false
                        });
                    })];
            });
        });
    };
    DeviceAsync.prototype.connectionType = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.loading) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.wait()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.isTizenOS()) {
                            return [2 /*return*/, this.tizenConnectionsStatus()];
                        }
                        else if (this.isLGWebOS()) {
                            return [2 /*return*/, this.webOsConnectionsStatus()];
                        }
                        return [2 /*return*/, device.device.connectionType()];
                }
            });
        });
    };
    DeviceAsync.prototype.wait = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.callbacks.push(resolve);
        });
    };
    return DeviceAsync;
}());
var deviceAsync = new DeviceAsync();

exports.DeviceAsync = DeviceAsync;
exports.deviceAsync = deviceAsync;
